import React from 'react'
import styled from 'styled-components';
import { EventInfo } from '../../../pms-calendar/lib/EventInfo';
import { getDayDiff } from '../../../../shared/utils/dateUtils';

interface CustomEventProps {
    left: number;
    width: number;
    color: string;
}

const CustomEvent = styled.div<CustomEventProps>`
  position: absolute;
  left: ${props => props.left}%;
  width: ${props => props.width}%;
  height: 30px;
  color: white;
  text-align: center;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  background-color: ${props => props.color};
  margin-top: 2.5px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50px;
    background-color: ${props => props.color};
    opacity: 0.7;
    z-index: -1;
  }
`;

const getDisplayTitle = (title: string, maxLength: number, eventInfo: any, dayDiff: number): string => {
    const today = new Date();
    const startDate = new Date(eventInfo.event.start);
    const endDate = new Date(eventInfo.event.end);

    // Jika start sudah lewat, gunakan selisih dari endDate ke hari ini
    const adjustedDayDiff = startDate < today
        ? Math.ceil((endDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24))
        : dayDiff;

    // Pastikan minimal dayDiff adalah 1
    const finalDayDiff = Math.max(1, adjustedDayDiff);

    // Tentukan panjang substring
    const substringLength = Math.min(title.length, finalDayDiff * maxLength);

    return title.length > substringLength ? title.substring(0, substringLength) + '...' : title;
};

const RoomMaintenance: React.FC<{ eventInfo: EventInfo }> = ({ eventInfo }) => {
    const dayDiff = getDayDiff(eventInfo.event.start, eventInfo.event.end);
    // const left = 100 / (dayDiff + 1) / 2;
    const left = 160 / (2 * (dayDiff + 1));
    const width = 100;

    const maxLength = 3;
    const title = eventInfo.event.title;
    const displayTitle = getDisplayTitle(title, maxLength, eventInfo, dayDiff);
    return (
        <CustomEvent
            color='#ff7a38'
            left={left}
            width={width}
            className='d-flex align-items-center justify-content-center'
            style={{ cursor: 'pointer' }}
            title='Click to edit'
        >
            <div className='d-flex'>
                <i>{displayTitle}</i>
            </div>
        </CustomEvent>
    );
}

// Booking sungguhan, ditampilkan READ-ONLY ("ghost") — warna netral (bukan oranye
// milik roomMaintenance, bukan merah cerah milik kalender reservasi asli) supaya
// jelas beda: kamar ini SUDAH ada tamunya, cuma untuk referensi, tidak bisa
// diklik/diseret dari sini (lihat eventAllow di CalendarComponent.tsx).
const BookingGhostEvent: React.FC<{ eventInfo: EventInfo }> = ({ eventInfo }) => {
    const dayDiff = getDayDiff(eventInfo.event.start, eventInfo.event.end);
    const left = 160 / (2 * (dayDiff + 1));
    const width = 100;

    const maxLength = 3;
    const title = eventInfo.event.title;
    const displayTitle = getDisplayTitle(title, maxLength, eventInfo, dayDiff);
    return (
        <CustomEvent
            color='#8a94a6'
            left={left}
            width={width}
            className='d-flex align-items-center justify-content-center'
            style={{ opacity: 0.75, cursor: 'not-allowed' }}
            title={`Booked: ${title} (read-only)`}
        >
            <div className='d-flex'>
                <i>{displayTitle}</i>
            </div>
        </CustomEvent>
    );
}

interface EventContentProps {
    eventInfo: EventInfo;
}

const AvailabilityEvent: React.FC<{ eventInfo: EventInfo }> = ({ eventInfo }) => (
    <div className='d-flex align-items-center justify-content-center text-black mt-2'>
        <b>{eventInfo.event.title}</b>
    </div>
);

const EventContent: React.FC<EventContentProps> = ({ eventInfo }) => {
    if (eventInfo.event.extendedProps?.type === 'roomMaintenance') {
        return (
            <RoomMaintenance eventInfo={eventInfo} />
        );
    } else if (eventInfo.event.extendedProps?.type === 'booking') {
        return (
            <BookingGhostEvent eventInfo={eventInfo} />
        );
    } else {
        return <AvailabilityEvent eventInfo={eventInfo} />;
    }
}

export default EventContent